import { render } from "./format-time.vue?vue&type=template&id=834e4066&ts=true"
import script from "./format-time.vue?vue&type=script&lang=ts"
export * from "./format-time.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__